import api from "../../../index";

// Create copilot chat category
export const createCopilotChatCategory = async (data: any) => {
  return await api.post("/copilot-chat-category", data);
};

// Get all copilot chat categories (admin)
export const getAllCopilotChatCategories = async () => {
  return await api.get("/copilot-chat-categories");
};

// Get active copilot chat categories (for extension)
export const getActiveCopilotChatCategories = async () => {
  return await api.get("/copilot-chat-categories/active");
};

// Get copilot chat category by id
export const getCopilotChatCategoryById = async (id: string) => {
  return await api.get(`/copilot-chat-category/${id}`);
};

// Update copilot chat category by id
export const updateCopilotChatCategoryById = async (id: string, data: any) => {
  return await api.put(`/copilot-chat-category/${id}`, data);
};

// Delete copilot chat category by id
export const deleteCopilotChatCategoryById = async (id: string) => {
  return await api.delete(`/copilot-chat-category/${id}`);
};
